export enum PortalState {
  FILL_SITE = 'FILL_SITE',
  SOURCE_SITE = 'SOURCE_SITE'
}
